const ANNOUNCEMENT = '/_exclusive/helps/bukabantuan-announcements';

export const retrieveBukabantuanPublicAnnouncements = ($axios, { offset, limit, platform }) => {
  const params = new URLSearchParams();
  if (offset) {
    params.append('offset', offset);
  }
  
  if (limit) {
    params.append('limit', limit);
  }

  if (platform) {
    params.append('platform', platform);
  }
  
  return $axios.$get(`${ANNOUNCEMENT}?${params.toString()}`);
};
